import { FormValues, NewApplicationListItem } from '../../types';

const updateApplicationValues = ({
  values,
  info,
}: {
  values: FormValues;
  info: NewApplicationListItem;
}) => {
  const stepOne = {
    firstName: values.firstName,
    lastName: values.lastName,
    phone: values.phone,
    email: values.email,
    participatesInPolitics: values.participatesInPolitics,
    isUSResident: values.isUSResident,
  };

  const currentStepTwo = {
    dob: values.dob,
    countryId: values.countryId,
    city: values.city,
    postalCode: values.postalCode,
    address1: values.address1,
    address2: values.address2,
    passportNumber: values.passportNumber,
    passportExpiredDate: values.passportExpiredDate,
  };

  const stepTwo = {
    sumSubStatus: info.sumSubApplication?.reviewStatus,
    ...currentStepTwo,
  };

  const nextInfo = {
    ...info,
    ...stepOne,
    ...stepTwo,
  };

  return nextInfo;
};

export default updateApplicationValues;
